import type { AxiosInstance } from "axios";
import { type ControllerFactory, getApiGen } from "./factory";
import { useState } from "react";
import { useUnsafeUpdatedRef } from "@mdotm/utils/react-extra";
/**
 * Example:
 * ```tsx
 * const portfolioApi = useApiGen(InvestmentsControllerApiFactory);
 * ```
 */
export function useApiGen<T>(controllerFactory: ControllerFactory<T>, axiosInstance?: AxiosInstance): T {
	const latestAxiosInstanceRef = useUnsafeUpdatedRef(axiosInstance);
	return useState(
		() =>
			new Proxy(
				{},
				{
					get(_, p) {
						return getApiGen(controllerFactory, latestAxiosInstanceRef.current)[p as keyof T];
					},
				},
			) as T,
	)[0];
}
